window.Bernie = window.Bernie || {};
var mod = require("-!/app/node_modules/ts-loader/index.js??ruleSet[1].rules[2].use[0]!/app/src/get-localization.ts");
Object.keys(mod).forEach(function (key) {
  window.Bernie[key] = mod[key];
});
module.exports = window.Bernie;